rdefine('app/products/components/CategoryItem',['backbone','text!products/category.html'],function(Backbone,template) {
    var Option = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'select-option',
        bindings:{
            el:{
                classes:{
                    active:'model.active',
                    disabled:'model.disabled'
                }
            },
            'div':{
                text:'model.name_default'
            },
            '.glyphicon':{
                toggle:{
                    data:'model.active'
                }
            }
        },
        events:{
            "click":"onClick"
        },
        parent:null,
        initialize:function(options) {
            //this.model = options.model;
            this.$el.html('<div></div><span class="glyphicon glyphicon-ok check-mark"></span>');
            this.parent = options.parent;
        },
        onClick: function() {
            var id = this.model.get('id');
            if(this.model.get("disabled",false)) {
                return;
            }
            $.getJSON(window.successurl, {
                breadcrumbs:true,
                category_id: id,
                is_create: window.is_create
            }, function(data){
                if(data && data.breadcrumbs) {
                    $(".dynamic-breadcrumbs").html(data.breadcrumbs);
                }
            });
            this.parent.collection.trigger('select',id);
        }
    });

    return Backbone.Ribs.View.extend({
        className:'col-xs-4',
        tagName:'div',
        bindings:{
            '.content':{
                collection: {
                    col:'ccol',
                    view:Option
                }
            }
        },
        ccol:null,
        initialize:function() {
            this.bindings[".content"].collection.data={parent:this};
            this.$el.html(template);
            this.ccol = new Backbone.Ribs.Collection(this.model.attributes.cats,{model:Backbone.Ribs.Model});
            this.model.on("change:cats",this.updateCats.bind(this));
        },
        updateCats:function() {
           this.ccol.reset(this.model.attributes.cats);
        }
    });
});